import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles, createStyles} from '@material-ui/styles';
import {Theme} from '@material-ui/core/styles';
import GridFormRow from 'cl-form/GridFormRow';

export interface GridFormHeaderProp {
  leftText: React.ReactNode;
  rightText: React.ReactNode;
}

const GridFormHeader: React.FunctionComponent<GridFormHeaderProp> = ({leftText, rightText}) => {
  const {root} = useStyles();
  const left = <Typography variant="caption">{leftText}</Typography>;
  const right = <Typography variant="caption">{rightText}</Typography>;
  return <GridFormRow left={left} right={right} showArrow={false} className={root} />;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(-4),
    },
  })
);

export default GridFormHeader;
